'use strict';

var boughtWithProducts = function () {
    var $boughtWithProductsContent = $('.boughtWithProductsContent');

    // Load div content with Ajax
    if ($boughtWithProductsContent.hasClass('async-load')) {
        $boughtWithProductsContent.asyncLoad(function __enableProductCarousel() {
            productTileSlick();
            $('.boughtWithProductsContent').refreshImages();
            updateQtyIncrementerButtonsState();
        });
    }
};

const stickyPdpActionBar = function () {
    const $pdpActionBtn = $('.pi--add-to-cart');
    const $pdpActionBar = $('.actions-pdp-sticky');
    const elementTop = $pdpActionBtn.offset().top - 75;
    let viewportTop = 0;
    let actionPdpActive = 'actions-pdp--active';

    const changeStateOnScroll = function () {
        viewportTop = $(window).scrollTop();
        if (elementTop < viewportTop) {
            $pdpActionBar.addClass(actionPdpActive);
        } else {
            $pdpActionBar.removeClass(actionPdpActive);
        }
    };

    changeStateOnScroll();
    $(window).on('scroll', _.throttle(changeStateOnScroll, 200));
};

const favoriteControl = function () {
    if (isAuthenticated) {
        const $favoriteBtn = $('.productPDP .addToCartStarter');
        let $otherFavoriteBtn = $favoriteBtn.not(this);

        $favoriteBtn.on('click', function() {
            if ($(this).hasClass('is_favorite')) {
                $otherFavoriteBtn.removeClass('is_favorite is_active').attr('aria-expanded', false);
            } else {
                $otherFavoriteBtn.addClass('is_favorite is_active').attr('aria-expanded', true);
            }

        });
    }
};

const relocateProductLegal = function () {
    const legalContent = $('#productLegal');
    const legalEcoFees = $('#handlingFeesLegal');
    var contentContainer = $('.legalPlaceholder');
    if (legalContent.length) {
        contentContainer.append(legalContent);
        legalContent.removeClass('hide');
    }
    if (legalEcoFees.length) {
        contentContainer.append(legalEcoFees);
        legalEcoFees.removeClass('hide');
    }
};

const bindVariantControls = function () {
    //colors variants section
    $('.colors-container .color-pastille').click(function () {
        let sku = $(this).attr("sku");
        $("select.select-variant.color-variant").val(sku).change();
    });
    $('.pi-actions-approx .see-more-link').click(function () {
        $(this).addClass('hide');
        $('.pi-actions-approx .see-less-link').removeClass('hide');
        $('.pi-actions-approx .colors-container').css('max-height','unset');
    });
    $('.pi-actions-approx .see-less-link').click(function () {
        $(this).addClass('hide');
        $('.pi-actions-approx .see-more-link').removeClass('hide');
        $('.pi-actions-approx .colors-container').css('max-height','13.2rem');
    });
};

const toggleFirstProductInfo = function () {
    let productToggleInfo = $('.product-info .pi-accordion-list .accordion--standalone');
    if (productToggleInfo.length) {
        productToggleInfo.first().find('.accordion--btn').click();
    }
};

const initPdpAccordions = function () {
    $('[data-feature="accordion-default"]:not(.accordion-default-is_initialized)').accordion_default();
};

jQuery(document).ready(function () {
    pdpCarouselSlick();
    boughtWithProducts();
    stickyPdpActionBar();
    favoriteControl();
    relocateProductLegal()
    push_product_detail_metrics();
    bindVariantControls();
    initPdpAccordions();
    toggleFirstProductInfo();
});

$(window).on('resize', _.throttle(stickyPdpActionBar, 500));